import { useSuspenseQuery, } from "@tanstack/react-query";
import { useConfigurationApi, useSessionId, } from "@plansoft-configuration-renderer/framework";
import { getConfigurationObjectPaths } from "./getConfigurationObjectPaths";
/**
 * @private ⚠️ Please do not export this from here ⚠️
 * @param options
 * @returns
 */
export function useLoadConfigurationObjectStubsByPath(options) {
    const { path } = options;
    const configurationApi = useConfigurationApi();
    const sessionId = useSessionId();
    const selectors = getConfigurationObjectPaths(path).map((path) => ({
        path,
        includeValues: true,
        includeSymbols: false,
        includeAttributes: true,
        includeProperties: false,
        // TODO: is it a good idea to include these? we cannot simply reload these every time ...
        includeNotActive: false,
        includeNotVisible: true,
    }));
    return useSuspenseQuery({
        queryKey: ["ConfigurationApi.getConfiguration", sessionId, selectors],
        queryFn: () => configurationApi.getConfiguration({
            id: sessionId,
            getConfigurationParams: {
                selectors,
            },
        }),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
}
//# sourceMappingURL=useLoadConfigurationObjectStubByPath.js.map